<template>
    <div :data-component="$options.name">
        <template v-if="searchFilters.id !== FilterId.FURNISHING_TYPES">
            <cs-checkbox
                v-for="value in searchFilters.values"
                :key="value.id"
                v-model="filterState[searchFilters.param_key]"
                :value="value.id"
                :name="value.label"
                @update:modelValue="
                    onUpdateModelValueCheckbox(
                        filterState[searchFilters.param_key],
                        searchFilters.param_key,
                        value.label,
                    )
                "
                >{{ value.label }}
            </cs-checkbox>
        </template>
        <template v-else>
            <cs-radio-button
                v-for="value in searchFilters.values"
                :key="value.id"
                v-model="filterState[searchFilters.param_key]"
                :value="value.id"
                :name="radioName"
                @update:modelValue="onUpdateModelValueRadio($event, searchFilters.param_key, value.label)"
                >{{ value.label }}</cs-radio-button
            >
        </template>
    </div>
</template>
<script lang="ts" src="./MsFilterEnhanced.ts" />
